<template>
<div class="chapter">
<div class="inner_page">
<p class="centera">Praise for <em>Close Quarters</em>:</p>
<p class="center1">‘[Walter Bain is] a classic creation . . . [It’s McAllister’s] experience of tenements, and his affection for them, despite all the drawbacks, that really animates <em>Close Quarters</em>. There will be few city-dwellers who don’t recognise some of their own lives here’</p>
<p class="center"><em>The Herald</em></p>
<p class="center1">‘The author re-imagines the Glasgow tenement lifestyle, fuelled by his own experiences of living in flats. There’s a touch of humour but there’s also an element of crime, the combination of which makes excellent reading’</p>
<p class="center"><em>The Scots Magazine</em></p>
<p class="center1">‘<em>Close Quarters</em> isn’t, oddly, really a crime novel, it’s far more a gentle satire about Glasgow and some of its denizens. The murder of Walter Bain is certainly central to the plot, but finding out who committed the crime turns out to be almost incidental to what follows, and to the considerable enjoyment this book gives the reader’</p>
<p class="center"><em>Undiscovered Scotland</em></p>
<p class="center1">‘A refreshing and well-written read’</p>
<p class="center"><em>That’s Books and Entertainment</em></p>
<p class="center1">‘<em>Close Quarters</em> has a cosy, farcical, stage-like quality that I really enjoyed . . . funny and poignant’</p>
<p class="center"><em>Mystery People</em></p>
<p class="center1">‘Some laugh-out-loud moments . . . a comedy wrapped around a whodunnit . . . will be enjoyed especially by anyone familiar with the West End’</p>
<p class="center"><em>The Westender Magazine</em></p>
<p class="center1">‘Tenement life gains a whole new perspective in Angus McAllister’s recently published murder mystery, and it’s a local novel that has particularly appealed to Glasgow’s bibliophiles . . . Full of witty observations about tenement life, this is a whodunnit with a decidedly Glaswegian twist’ Rachel Walker<em>,</em> Scottish Writers’ Centre, <em>Books Set in Glasgow</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?72f3962a